import initialState from './initialState';
import {
  USER_ADMIN_GET_LIST_INIT,
  USER_ADMIN_GET_LIST_SUCCESS,
  USER_ADMIN_GET_LIST_FAILURE,
  USER_ADMIN_SAVE_INIT,
  USER_ADMIN_SAVE_SUCCESS,
  USER_ADMIN_SAVE_FAILURE,
  USER_ADMIN_SET_SAVE_DATA_BY_KEY,
  USER_ADMIN_SAVE_RESET,
  USER_ADMIN_DELETE_PREPARE_INIT,
  USER_ADMIN_DELETE_INIT,
  USER_ADMIN_DELETE_SUCCESS,
  USER_ADMIN_DELETE_FAILURE,
  USER_DOWNLOAD_IMPORT_FILE_INIT,
  USER_DOWNLOAD_IMPORT_FILE_SUCCESS,
  USER_DOWNLOAD_IMPORT_FILE_FAILURE,
  USER_IMPORT_INIT,
  USER_IMPORT_SUCCESS,
  USER_IMPORT_FAILURE,
  USER_IMPORT_RESET,
  USER_ADMIN_GET_GROUPS_INIT,
  USER_ADMIN_GET_GROUPS_SUCCESS,
  USER_ADMIN_GET_GROUPS_FAILURE,
  USER_ADMIN_CONFIRM_USER_INIT,
  USER_ADMIN_CONFIRM_USER_SUCCESS,
  USER_ADMIN_CONFIRM_USER_FAILURE,
  USER_ADMIN_GET_BI_TEMPLATES_LIST_INIT,
  USER_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS,
  USER_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE,
  USER_ADMIN_RESET
} from '../../actions/userAdmin/types';
import ReducersTooling from '../../../tooling/reducersTooling';

export default function userAdmin(state = initialState, action) {
  switch (action.type) {      
    case USER_ADMIN_GET_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "list");
    case USER_ADMIN_GET_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "list");
    case USER_ADMIN_GET_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "list");
    case USER_ADMIN_SAVE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitSave(initialState, state, action, "save");
    case USER_ADMIN_SAVE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessSave(initialState, state, action, "save");
    case USER_ADMIN_SAVE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureSave(initialState, state, action, "save");
    case USER_ADMIN_SET_SAVE_DATA_BY_KEY:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSetDataByKeySave(initialState, state, action, "save");
    case USER_ADMIN_SAVE_RESET:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateResetSave(initialState, state, action, "save");
    case USER_ADMIN_DELETE_PREPARE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStatePrepareDelete(initialState, state, action, "delete");
    case USER_ADMIN_DELETE_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitDelete(initialState, state, action, "delete");
    case USER_ADMIN_DELETE_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessDelete(initialState, state, action, "delete");
    case USER_ADMIN_DELETE_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureDelete(initialState, state, action, "delete");
    case USER_DOWNLOAD_IMPORT_FILE_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "downloadImport");
    case USER_DOWNLOAD_IMPORT_FILE_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "downloadImport");
    case USER_DOWNLOAD_IMPORT_FILE_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "downloadImport");
    case USER_IMPORT_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "import");
    case USER_IMPORT_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "import");
    case USER_IMPORT_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "import");
    case USER_IMPORT_RESET:
      return ReducersTooling.generalReducers.getFetchTypeNewStateReset(initialState, state, action, "import");
    case USER_ADMIN_GET_GROUPS_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "groupsData");
    case USER_ADMIN_GET_GROUPS_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "groupsData");
    case USER_ADMIN_GET_GROUPS_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "groupsData");
    case USER_ADMIN_CONFIRM_USER_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "confirmUser");
    case USER_ADMIN_CONFIRM_USER_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "confirmUser");
    case USER_ADMIN_CONFIRM_USER_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "confirmUser");
    case USER_ADMIN_GET_BI_TEMPLATES_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "biTemplatesList");
    case USER_ADMIN_GET_BI_TEMPLATES_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "biTemplatesList");
    case USER_ADMIN_GET_BI_TEMPLATES_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "biTemplatesList");
    case USER_ADMIN_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/userAdmin/index.js